import { useMenu } from '../../../../../../../hooks/useMenu';
import { MassActionsFilterConfig } from '../../../massActionsBar.types';

interface UseMassActionsSelectionMenuParams {
  toggleAllSelected: () => void;
  deselectAll?: () => void;
  massActionFilter?: MassActionsFilterConfig;
}

export function useMassActionsSelectionMenu({
  toggleAllSelected,
  deselectAll,
  massActionFilter,
}: UseMassActionsSelectionMenuParams) {
  const { anchorEl, isOpen: isMenuOpen, open: openMenu, close: closeMenu } = useMenu();

  const handleSelectAllResults = () => {
    if (massActionFilter?.enabled && !massActionFilter.value) {
      massActionFilter.onToggle();
    }
    closeMenu();
  };

  const handleDeselectAll = () => {
    if (massActionFilter?.enabled && massActionFilter.value) {
      massActionFilter.onToggle();
    } else {
      (deselectAll ?? toggleAllSelected)();
    }
    closeMenu();
  };

  return {
    isMenuOpen,
    anchorEl,
    openMenu,
    closeMenu,
    handleSelectAllResults,
    handleDeselectAll,
  };
}
